/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

const Wz01: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Baśnie");
  const [text2, setText2] = useState<string>("Antosia");
  const [text3, setText3] = useState<string>("10.01.2026");
  const [text4, setText4] = useState<string>("55cm | 2660g | 18:59");
  const [text5, setText5] = useState<string>("Na pamiątkę Chrztu Świętego");
  const [text6, setText6] = useState<string>("od Mamy Chrzestnej Moniki");
  const [fontSizeText1, setFontSizeText1] = useState<number>(118);
  const [fontSizeText2, setFontSizeText2] = useState<number>(118);
  const [fontSizeText3, setFontSizeText3] = useState<number>(50);
  const [fontSizeText4, setFontSizeText4] = useState<number>(36);
  const [fontSizeText5, setFontSizeText5] = useState<number>(32);
  const [fontSizeText6, setFontSizeText6] = useState<number>(32);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm (A4 size)
  const maxWidth = 550; // Maximum width for text

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'HandycheeraRegular', 'HandycheeraRegular'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'HandycheeraRegular', 'HandycheeraRegular'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'HandycheeraRegular', 'HandycheeraRegular'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, 118, 20));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, 118, 30));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, 50, 15));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize(text4, fontSizeText4, 36, 10));
  }, [text4]);

  useEffect(() => {
    setFontSizeText5(adjustFontSize(text5, fontSizeText5, 32, 10));
  }, [text5]);

  useEffect(() => {
    setFontSizeText6(adjustFontSize(text6, fontSizeText6, 32, 10));
  }, [text6]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null, // No image provided
      false // Disable the image requirement
    );
  };

  return (<div style={{
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff", padding: "60px",
    position: "relative",
  }}>
    {/* Spinner Overlay */}
    <SpinnerOverlay isVisible={isSaving} />
    <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>

        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
    </div>

      <div
      id="printable-content"
      style={{
        position: "relative",
        width: pdfWidth,
        height: pdfHeight,
        fontFamily: "HandycheeraRegular, ArimaMadurai-Regular",
        backgroundColor: "#ffffff",
        margin: "auto",
        marginTop: "20px"
      }}
    >
        {/* Dynamic Text 1 */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          classes=""
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: "HandycheeraRegular",
            textAlign: "center",
            position: 'absolute',
            top: '230px',
            left: '25px',
            right: '0',
            width: '80%',
            margin: 'auto',
            color: "#739ecd",
            zIndex:33,
          }}
        />

        {/* Dynamic Text 2 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          classes="wz01-text wz01-text-2"
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: "HandycheeraRegular",
            textAlign: "center",
            position: 'absolute',
            top: '380px',
            left: '25px',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400',
            color: "#3e5991"
          }}
        />

        {/* Dynamic Text 3 */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          classes="wz01-text wz01-text-3"
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: "ArimaMadurai-Regular",
            textAlign: "center",
            position: 'absolute',
            bottom: '460px',
            left: '25px',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400',
            color: "#796c54"
          }}
        />

        {/* Dynamic Text 4 */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          classes="wz01-text wz01-text-4"
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: "ArimaMadurai-Regular",
            textAlign: "center",
            position: 'absolute',
            bottom: '410px',
            left: '25px',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400',
            color: "#796c54"
          }}
        />

        <InlineEdit
          value={text5}
          setValue={setText5}
          classes="wz01-text wz01-text-4"
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: "ArimaMadurai-Regular",
            textAlign: "center",
            position: 'absolute',
            bottom: '330px',
            left: '25px',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400',
            color: "#796c54"
          }}
        />

        <InlineEdit
          value={text6}
          setValue={setText6}
          classes="wz01-text wz01-text-4"
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: "ArimaMadurai-Regular",
            textAlign: "center",
            position: 'absolute',
            bottom: '280px',
            left: '25px',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400',
            color: "#796c54"
          }}
        />

        {/* Background Image */}
        <img
          className="wzor-25-bg"
          src="/images/Basnie1.svg"
          style={{ width: "100%", height: "100%", zIndex: '5', position: 'absolute', top: '0', bottom: '0', left: '0', right: '0' }}
        />
      </div>
    </div>
  );
};

export default Wz01;
